import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { fadeUp, viewport } from "../../lib/motion";

/** Audience card: photo with green circular icon overlapping bottom, uppercase heading. */
export default function AudienceCard({ audience }) {
  const IconCmp = Icons[toPascal(audience.icon)] || Icons.Sparkles;
  return (
    <motion.div
      variants={fadeUp}
      initial="hidden"
      whileInView="show"
      viewport={viewport}
      className="relative flex flex-col group"
      data-testid={`audience-card-${audience.id}`}
    >
      <div className="relative overflow-hidden aspect-[4/3] border border-charcoal/60">
        <img
          src={audience.image}
          alt={audience.label}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-[1.05]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-ink/80" />
        <div className="absolute left-1/2 -translate-x-1/2 -bottom-6 w-12 h-12 rounded-full bg-emerald text-ink grid place-items-center border-4 border-ink shadow-lg">
          <IconCmp className="w-5 h-5" />
        </div>
      </div>
      <div className="pt-10 text-center">
        <div className="text-emerald text-xs md:text-sm font-display font-bold uppercase tracking-[0.22em]">
          {audience.label}
        </div>
        <div className="mt-2 text-mutedtext text-sm leading-relaxed max-w-[22ch] mx-auto">
          {audience.body}
        </div>
      </div>
    </motion.div>
  );
}

function toPascal(kebab) {
  return kebab
    .split("-")
    .map((s) => s[0].toUpperCase() + s.slice(1))
    .join("");
}
